import namespace from './namespace';
import {mapUsersByEmailResultEnum} from "./enums/mapUsersByEmailResultEnum";

export default {
    [namespace.state.DEFAULT_VALUES]: [],
    [namespace.state.AVAILABLE_VALUES]: [],
    [namespace.state.SPECIAL_VALUES]: [],
    [namespace.state.LOADER_VISIBLE]: false,
    mapUsersByEmailResult: mapUsersByEmailResultEnum.NONE,
    mapUsersByEmailResultMessage: {
        title: '',
        content: ''
    }
};


// WEBPACK FOOTER //
// ./src/store/modules/usersMapping/state.js